module.exports = __webpack_public_path__ + "img/icon-1.359593fc.png";